import { OGProperties, PageTags } from '../types';
import { RoutesPaths } from '@router/constants';

const title = 'Account Portfolio'
const url = window.location.origin + RoutesPaths.ACCOUNT.MAIN

export const accountPortfolio: PageTags = {
  title: `| ${title}`,
  url: url,
  properties: [
    {
      property: OGProperties.title,
      content: `FireStarter | ${title}`,
    },
    {
      property: OGProperties.description,
      content: 'Claim your rewards for participating in FireStarter projects',
    },
    {
      property: OGProperties.url,
      content: url,
    },
  ]
}
